export function readTime(html) {
  let tmp = document.implementation.createHTMLDocument("New").body
  tmp.innerHTML = html
  let text = tmp.textContent || tmp.innerText || "";
  const wpm = 225
  const words = text.trim().split(/\s+/).length
  return Math.ceil(words / wpm)
}
